module.exports = __webpack_public_path__ + "images/bubble-arrow-5d50c36c83dc96febbe2268d261a895f.png";